import { getStore, initialStore } from '../store/store';
import { mutator } from 'satcheljs';
import {
    onNewFolderMenuClicked,
    onNewFolderTextChanged,
    onSearchTextChanged,
    onViewAllMenuClicked,
    resetNewFolderViewState,
} from '../actions/internalActions';

// initialises new folder view state
mutator(onNewFolderMenuClicked, () => {
    getStore().newFolderViewState = {
        folderText: '',
        isInvalid: false,
    };
});

// sets the new folder's text
mutator(onNewFolderTextChanged, actionMessage => {
    const moveToStore = getStore();
    if (actionMessage.folderText.trim().length > 0) {
        moveToStore.newFolderViewState = {
            folderText: actionMessage.folderText,
            isInvalid: false,
        };
    } else {
        moveToStore.newFolderViewState = {
            folderText: '',
            isInvalid: false,
        };
    }
});

// resets new folder view state to initial value
mutator(onSearchTextChanged, () => {
    getStore().newFolderViewState = initialStore.newFolderViewState;
});

// resets new folder view state to initial value
mutator(onViewAllMenuClicked, () => {
    getStore().newFolderViewState = initialStore.newFolderViewState;
});

// resets new folder view state to initial value
mutator(resetNewFolderViewState, () => {
    getStore().newFolderViewState = initialStore.newFolderViewState;
});
